import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { Toaster } from 'sonner'
import { useAuth } from './stores/auth'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/Login'
import { AuthCallback } from './pages/AuthCallback'
import { DashboardPage } from './pages/Dashboard'
import { EventsPage } from './pages/Events'
import { EventDetailPage } from './pages/EventDetail'
import { EventCreatePage } from './pages/EventCreate'
import { EventEditPage } from './pages/EventEdit'
import { GuestsPage } from './pages/Guests'
import { SettingsPage } from './pages/Settings'
import { AnalyticsPage } from './pages/Analytics'
import { CampaignsPage } from './pages/Campaigns'
import { CampaignEditPage } from './pages/CampaignEdit'
import { StaffPage } from './pages/Staff'
import { OnboardingPage } from './pages/Onboarding'
import { SignupPage } from './pages/Signup'
import { NotFoundPage } from './pages/NotFound'
import { SubscriptionGuard } from './components/SubscriptionGuard'
import { ErrorBoundary } from './components/ErrorBoundary'

function ProtectedRoute() {
  const { user, staff, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-slate-400 mt-4">Laden...</p>
        </div>
      </div>
    )
  }

  if (!user || !staff) {
    return <Navigate to="/login" replace />
  }

  return (
    <Layout>
      <SubscriptionGuard>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </SubscriptionGuard>
    </Layout>
  )
}

export default function App() {
  const init = useAuth((s) => s.init)

  useEffect(() => { init() }, [init])

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: { background: '#1e1b4b', border: '1px solid #312e81', color: '#e0e7ff' },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/onboarding" element={<OnboardingPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/new" element={<EventCreatePage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/events/:id/edit" element={<EventEditPage />} />
          <Route path="/guests" element={<GuestsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/campaigns/new" element={<CampaignEditPage />} />
          <Route path="/campaigns/:id/edit" element={<CampaignEditPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/payment" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}
